var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.323,
    height: 48.939,
    viewBox: "0 0 47.323 48.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105759",
    "data-name": "Group 105759",
    transform: "translate(-475 -262.531)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 23.662,
    cy: 24.469,
    rx: 23.662,
    ry: 24.469,
    transform: "translate(475 262.531)",
    fill: "#29c6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-food",
    "data-name": "Icon map-food",
    d: "M20,7.346,18.416,19.763h-5.35L11.488,7.284H18.02l1.291-4.459.732.221L18.8,7.337l1.2.009ZM10.732,14.53s.2-1.61-2.574-1.61H3.739c-2.77,0-2.574,1.61-2.574,1.61h9.567ZM1.164,18.153s-.2,1.61,2.574,1.61H8.158c2.774,0,2.574-1.61,2.574-1.61Zm9.152-.805a.926.926,0,0,0,.821-1.006.925.925,0,0,0-.821-1.007H1.541A.926.926,0,0,0,.72,16.342a.928.928,0,0,0,.821,1.006h8.776Z",
    transform: "translate(486.279 273.707)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.2557ab376ea6ba2ba387fc2cb7532d6c.svg";
export { ForwardRef as ReactComponent };